import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { ContextualBanner } from '@calendly/ui/components/contextual-banner'
import { ArrowExpandIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
import { useSelector } from 'react-redux'

import { isAdminOrOwnerSelector, isGroupAdminSelector } from 'selectors/current_user'


export const NoSeatsBanner = () => {
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector)
  const isGroupAdmin = useSelector(isGroupAdminSelector)

  return (
    <div data-component="no-seats-available-banner">
      <ContextualBanner variant="danger" spacingTop={16}>
        <BodyText>
          <b>{I18n.t('publisher.add_users_modal.no_seats_banner.lead')}</b>
&nbsp;
          {isAdminOrOwner && I18n.t('publisher.add_users_modal.no_seats_banner.admin_text')}
          {isGroupAdmin && !isAdminOrOwner && I18n.t('publisher.add_users_modal.no_seats_banner.group_admin_text')}
        </BodyText>
        {isAdminOrOwner && (
        <Button spacingTop={12} onClick={() => { window.open('/app/admin/billing', '_blank') }}>
          {I18n.t('publisher.add_users_modal.add_seats')}
&nbsp;
          <ArrowExpandIcon />
        </Button>
        )}
      </ContextualBanner>
    </div>
  )
}
